import styled from "styled-components";

const HEIGHT = 72;
const PADDING = 40;
const isDarkMode = (theme: any) => theme.palette.mode === "dark";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background-color: ${({ theme }) =>
    isDarkMode(theme) ? theme.colors.value_45 : theme.colors.value_01};
`;

export const UpContainer = styled.div`
  display: flex;
  height: ${({ theme }) => theme.coefficient * HEIGHT}px;
  padding: ${({ theme }) =>
    `0 ${theme.coefficient * PADDING}px 0 ${theme.coefficient * PADDING}px`};
  background-color: ${({ theme }) =>
    isDarkMode(theme) ? theme.colors.value_47 : theme.colors.value_17};
  border-bottom: 1px solid
    ${({ theme }) => (isDarkMode(theme) ? theme.colors.value_33 : "transparent")};
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  padding: ${({ theme }) =>
    `0 ${theme.coefficient * PADDING}px ${theme.coefficient * PADDING}px ${
      theme.coefficient * PADDING
    }px`};
  background-color: ${({ theme }) =>
    isDarkMode(theme) ? theme.colors.value_45 : theme.colors.value_01};
`;
